/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React, { useState, useEffect } from "react";
import moment from "moment";
import toast from "react-hot-toast";

import Card from "src/components/cards/Card.react";
import EditBoltResultSlideover from "src/components/slideovers/EditBoltResult.react";

import SingleBolt from "src/views/report/custom/SingleBolt.react";
import PrintHeader from "src/components/print/PrintHeader.react";

import { queryBoltInspection } from "src/services/AmplifyQuery";

/**
 * The Bolt component
 *
 * @author Thais Watanabe
 */
const Bolt = (props) => {
  const {
    turbineInspection,
    inspectionModelItems,
    inspectionModel,
    results,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
    print,
  } = props;

  const [activeTab, setActiveTab] = useState("14-1");
  const [selectedResult, setSelectedResult] = useState(null);
  const [boltInspection, setBoltInspection] = useState(null);
  const [boltToInspection, setBoltToInspection] = useState(null);
  const [isEditBoltOpen, setIsEditBoltOpen] = useState(false);

  /**
   * openBoltEdit
   * @param {*} inspectionModelItem
   * @param {*} inspectionResult
   */
  function openBoltEdit(inspectionModelItem, inspectionResult) {
    if (!inspectionResult) {
      toast.error("修正できません");
    } else {
      // setSelectedItem(inspectionModelItem);
      setSelectedResult(inspectionResult);
      setIsEditBoltOpen(!isEditBoltOpen);
    }
  }

  /* useEffect */
  useEffect(() => {
    if (boltInspection) {
      const quantity = boltInspection?.bolt?.quantity;
      const toInspect = boltInspection?.bolt?.quantity / 8;
      const startNumber = boltInspection?.startNumber;

      let listToInspect = [];

      for (var i = startNumber; i < quantity; i += toInspect) {
        listToInspect.push(i);
      }

      setBoltToInspection(listToInspect);
    }
  }, [boltInspection]);

  /* useEffect */
  useEffect(() => {
    fetchBoltInspection();

    return () => {
      setBoltInspection([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * fetchBoltInspection
   */
  async function fetchBoltInspection() {
    const filter = {
      and: [
        { date: { le: moment(inspection.createdAt).format("YYYY-MM-DD") } },
        { itemId: { eq: activeTab } },
      ],
    };

    queryBoltInspection(filter, null, [], setBoltInspection);

    // for (i in startNumber..bolt!!.quantity step toInspect) {
    //     boltsToInspect.add(i)
    // }
  }

  /* useEffect */
  useEffect(() => {
    setSelectedResult(results.find((obj) => obj.itemId === activeTab));
  }, [results, activeTab]);

  /**
   * isOptionSelected
   * @param {*} selected
   */
  function isOptionSelected(selected) {
    if (activeTab === selected) {
      return "border-teal-500 text-teal-600";
    } else {
      return "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300";
    }
  }

  /**
   * handleChange
   * @param {*} tab
   */
  const handleChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <Card className="hide-print">
        <div className="pt-5">
          <div className="sm:hidden">
            <label htmlFor="tabs" className="sr-only">
              選択してください
            </label>
            <select
              id="tabs"
              name="tabs"
              className="block w-full focus:ring-teal-500 focus:border-teal-500 border-gray-300 rounded-md"
              value={activeTab}
              onChange={handleChange}
            >
              {inspectionModelItems &&
                inspectionModelItems
                  .sort((a, b) =>
                    a.itemModelNumber > b.itemModelNumber ? 1 : -1
                  )
                  .map((model, i) => (
                    <option key={i} value={model.name}>
                      {model.name.split("-")[1]}
                    </option>
                  ))}
            </select>
          </div>
          <div className="hidden sm:block">
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex" aria-label="Tabs">
                {inspectionModelItems &&
                  inspectionModelItems.map((model, i) => (
                    <button
                      key={i}
                      className={`${isOptionSelected(
                        model.name
                      )} w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm`}
                      onClick={() => handleChange(model.name)}
                    >
                      {model.name.split("-")[1]}
                    </button>
                  ))}
              </nav>
            </div>
          </div>
        </div>
      </Card>

      {print ? (
        inspectionModelItems &&
        inspectionModelItems
          .sort((a, b) => (a.itemModelNumber > b.itemModelNumber ? 1 : -1))
          .map((model, i) => (
            <div key={i} className="pagebreak">
              <PrintHeader
                inspectionModel={inspectionModel}
                inspection={inspection}
                turbineInspection={turbineInspection}
              />

              <SingleBolt
                activeTab={model.name}
                inspectionModelItems={inspectionModelItems}
                openEdit={openEdit}
                openObs={openObs}
                turbineInspection={turbineInspection}
                selectedResult={selectedResult}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
                openBoltEdit={openBoltEdit}
                boltToInspection={boltToInspection}
              />
            </div>
          ))
      ) : (
        <SingleBolt
          activeTab={activeTab}
          inspectionModelItems={inspectionModelItems}
          openEdit={openEdit}
          openObs={openObs}
          turbineInspection={turbineInspection}
          selectedResult={selectedResult}
          lastTurbineInspections={lastTurbineInspections}
          inspection={inspection}
          openBoltEdit={openBoltEdit}
          boltToInspection={boltToInspection}
        />
      )}

      <EditBoltResultSlideover
        isEditBoltOpen={isEditBoltOpen}
        updateEdit={setIsEditBoltOpen}
        inspectionModelItem={inspectionModelItems.find(
          (obj) => obj.name === activeTab
        )}
        inspectionResult={selectedResult}
      />
    </div>
  );
};

export default Bolt;
